export type UserLocationLookupResponse = {
	ip: string | null;
	code: string;
	name: string | null;
};

export const isUserLocationLookupResponse = (
	json: unknown,
): json is UserLocationLookupResponse => {
	return (
		typeof json === "object" &&
		json !== null &&
		"ip" in json &&
		"code" in json &&
		"name" in json
	);
};
